import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeopleVoice"><Path d="M7 16C9.76142 16 12 18.2386 12 21V22H2V21C2 18.2386 4.23858 16 7 16ZM18 16H16V2H18V16ZM7 9C8.65685 9 10 10.3431 10 12C10 13.6569 8.65685 15 7 15C5.34315 15 4 13.6569 4 12C4 10.3431 5.34315 9 7 9ZM14 13H12V5H14V13ZM22 11H20V7H22V11ZM10 7H8V3H10V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleVoice;
